/* global axios */
import ApiClient from '../ApiClient';

class WgptBotEvalRecommendationsAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/eval_recommendations`, {
      accountScoped: true,
      wgpt: true,
    });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default WgptBotEvalRecommendationsAPI;
